// import logo from './logo.svg';
import "./App.css";
import Rose from "./images/Rose.jpeg";
import Charlie from "./images/Charlie.jpeg";
import Justin from "./images/Justin.jpeg";
import Jonathan from "./images/Jonathan.png";
import Emma from "./images/Emma.jpeg";
import GroupPhoto from "./images/KKPsi-group.JPG";
import Scroggs from "./images/Scroggs.png";
import NatCon from "./images/NatCon.png";
import Travel from "./images/Travel.png";
import Airbnb from "./images/Airbnb.png";
import Don1 from "./images/DonoPromo1.JPG";
import Don2 from "./images/DonoPromo2.JPG";
import Don3 from "./images/DonoPromo3.JPG";

import DonorInfo from "./images/Donation-Info.png";

function App() {
  return (
    <body>
      <div id="Title-Header">
        <div id="Title-Container">
          <div id="KKPsi-Title">KKPsi Theta Beta</div>
          <div id="NatCon-Title">NatCon Donation Campaign!</div>
        </div>
        <div id="Button-Container">
          {/* fix buttons  link to bu donation:https://trusted.bu.edu/s/1759/22/form.aspx?sid=1759&gid=2&pgid=412&cid=1044&appealcode=WEBAGC-CSDN*/}
          <a class="donate-button" id="bu-button" href="#Venmo-Donation">
            Make a Donation!
          </a>
          <a href="#Contact-Us">Contact Us!</a>
          <a href="https://kkpsitb.wixsite.com/bubands" target="_blank">
            Main Website
          </a>
        </div>
      </div>
      <div id="Scroll-Container">
        <h1 id="About-Us-Title">About Us!</h1>
        <div class="group" id="Theta-Beta">
          <div class="text-container">
            <div>
              <h2>About Theta Beta</h2>
              <p>
                We are a co-ed band service fraternity at Boston University!
                Theta Beta is a Northeast District chapter founded just over 41
                years ago. Our service includes maintenancing, setting up, and
                keeping inventory of band equipment. Our job is to ensure band
                performances are prepared to look and sound great! Among many
                other chapters around the nation, we{" "}
                <em>strive for the highest</em> in all aspects of our lives!
              </p>
            </div>
          </div>
          <div class="img-container">
            <img src={GroupPhoto}></img>
          </div>
        </div>
        <div class="group" id="Scroggs-Founders">
          <div class="text-container">
            <h2>William A. Scroggs Founder's Trophy</h2>
            <p>
              The William A. Scroggs Founder's Trophy has been presented at each
              National Convention since 1957. For a chapter to be handed this
              trophy is to be recognized as the{" "}
              <b>most outstanding chapter in the nation</b>! Theta Beta was
              recently nominated for this award. Being nominated alone
              demonstrates the hard work we put into this chapter! By supporting
              our journey to NatCon you are also supporting our Brothers who
              serve to showcase our chapter's achievements!
            </p>
          </div>
          <div class="img-container">
            <img src={Scroggs}></img>
          </div>
        </div>
        <div class="group" id="Journey to NatCon!">
          <div class="text-container">
            <h2>Journey to Natcon</h2>
            <p>
              Our Brothers have quite the journey ahead to Lexington, Kentucky!
              They are coming from different areas around the US, which means
              taking connecting flights, trains, and carpools! The range of
              distance our Brother's traveled from their home to Lexington goes
              from 635-1,730 miles! They have coordinated with our Sisters from
              BU's Eta Gamma chapter to rent an Airbnb for this trip! A lot of
              ahead thinking was done in preparation for this trip! With your
              help, our 5 Brothers can strive beyond financial hardship in order
              to experience the wonders of National Convention, or NatCon!
            </p>
          </div>
          <div class="img-container">
            <img src={NatCon}></img>
          </div>
        </div>

        <h1>Мeet Our Brothers Attending NatCon!</h1>
        <div class="group" id="Emma-Story">
          <div class="text-container">
            <h2>Meet Emma!</h2>
            <p>
              Emma is a rising sophomore studying Marine Sciences. She is our
              History and Alumni Liaison, after becoming an active member in
              2025! She joined with the Alpha Chi class and is in the Dom F.
              Coloyan line! Brother Nessie plays clarinet and multiple front
              ensemble instruments for pep Band, Marching Band, Concert Band,
              and Winter Drumline!
            </p>
            <p>
              "I've heard a lot from the Brothers who went this past year and
              how the experience positively influenced them. Knowing that NatCon
              will be similar but on a bigger scale made me excited to learn new
              things I can take home to my Brothers. I look forward to getting
              to meet and get to know Brothers from different chapters across
              the country. It will be fun to connect with them and make new
              friends who I can keep in touch with. I'd love to learn about the
              little things about their chapters that make them special, the
              same way Theta Beta has its own quirks that make us special. I
              will take this experience to heart and apply it in my life so that
              I may be a better leader, musician, Brother, and person. After
              NatCon, I will ensure that Brothers who weren't able to attend are
              caught up to speed so that Theta Beta as a whole can grow from
              this experience."
            </p>
          </div>
          <div class="img-container">
            <img id="Emma-photo" src={Emma}></img>
          </div>
        </div>

        <div class="group" id="Rose-Story">
          <div class="text-container">
            <h2>Meet Rose!</h2>
            <p>
              Rose is a rising junior studying Astronomy and Physics! She is our
              Social Media Chair this year! Rose will have been a member for 3
              years in the Alpha Phi class, in the T. Anthony line! Brother
              Laika plays trumpet for Marching Band and Pep Band!
            </p>

            <p>
              "This is my first convention and I haven’t really interacted with
              the chapter on a district or national level and I wanted to
              experience that while I still had the time. I’m looking forward to
              interacting with other chapters, attending workshops, and just
              learning about how the chapter is on a national level. I hope to
              take away lots of lessons and experiences that will help me make
              Theta Beta a better place and encourage everyone to be their best
              for each other. I love this chapter dearly and I would love to see
              it grow."
            </p>
          </div>
          <div class="img-container">
            <img id="Rose-photo" src={Rose}></img>
          </div>
        </div>

        <div class="group" id="Jonathan-Story">
          <div class="text-container">
            <h2>Meet Jonathan!</h2>
            <p>
              Jonathan is a recent graduate, having studied Anthropology and
              Psychology. He joined 3 years ago along with the Alpha Upsilon
              class and is a part of the T. Anthony Line. Last year, he served
              our chapter as Brotherhood Chair! Brother Equinox played saxophone
              for Pep band, trumpet for Matching Band, and percussion for Winter
              Drumline. He will be attending NatCon as a proxy- Go Jon!
            </p>
            <p>
              It’s my first time going to NATCon! I’ve been wanting to go since
              my first NEDCon. I made many friends and connections, and they
              have been one of my most memorable moments in KKPsi. I want to
              attend this convention as an active before I move on to the real
              world. Theta Beta is a finalist in the National Top Chapter Award,
              which I have put my efforts into process as Brotherhood Chair. I
              wanted to give our chapter the chance it deserves to the top in
              our fraternity’s history. This would be one of the most important
              events of our chapter in 41 years, so I’m giving it my all to help
              us achieve the award. This will be my last time attending a
              convention before I become an alumnus. I want to make sure our
              chapter strives for the highest, especially if it means taking
              home an award. I want our chapter to be recognized for all our
              hard work and efforts.
            </p>
          </div>
          <div class="img-container">
            <img id="Jonathan-photo" src={Jonathan}></img>
          </div>
        </div>

        <div class="group" id="Charlie-Story">
          <div class="text-container">
            <h2>Meet Charlie!</h2>
            <p>
              Charlie is a rising senior studying Political Sciences and
              International Relations with a minor in Data Sciences. He joined
              almost 3 years ago with the Alpha Upsilon class and is in the T.
              Anthony Line. Last year he served our chapter as Treasurer, and
              now attends NatCon as a delegate! Brother Azelf plays mellophone
              for both Pep Band and Marching Band. We are proud to have him
              represent Theta Beta this year! Go Charlie!
            </p>
            <p>
              "I'm so grateful for the honor and privilege of being elected
              Theta Beta's delegate, the important work of considering
              constitutional amendments, sitting on specialized committees, and
              electing national officers is at the core of our national
              conventions and I'm excited to have the opportunity to
              participate. One of my favorite things about going to conventions
              is getting a glimpse into other chapters and their members,
              service, and traditions. Getting to know Brothers from other
              chapters is also always a blast! As I enter my senior year and my
              third year as an active Brother, I want to use this opportunity to
              find ways to leave my chapter and my ensembles better than I found
              them. I also want to hear from alumni about staying involved after
              graduation and making music after college."
            </p>
          </div>
          <div class="img-container">
            <img id="Charlie-photo" src={Charlie}></img>
          </div>
        </div>

        <div class="group" id="Justin-Story">
          <div class="text-container">
            <h2>Meet Justin!</h2>
            <p>
              Justin is a rising sophomore studing Music and Psychology. He
              joined KKPsi this year along with the Alpha Chi class and is in
              the T. Anthony Line. Brother Echo plays trumpet for Pep Band,
              Marching Band, and Concert Band.This year he is our Brotherhood
              chair, taking after Jonathan!
            </p>
            <p>
              "I wanted to have the opportunity to travel with the Brothers and
              get to meet Brothers from other chapters and do an interview or
              two! Going to NATCon will give me the experience of going on an
              airplane for the first time, planing out how the trip will go,
              improving my interpersonal skills, and expanding my knowledge
              about the fraternity as a whole. I look forward to the banquet,
              the workshops, the Airbnb experience, and visiting Kentucky for
              the first time!"
            </p>
          </div>
          <div class="img-container">
            <img id="Justin-photo" src={Justin}></img>
          </div>
        </div>

        <h1>Breakdown of Costs</h1>

        <div class="group" id="Travel">
          <div class="text-container">
            <h2>Travel</h2>
            <p>
              Our Brothers are coming from a multitude of places to Lexington;
              our farthest Brother is Emma- 1,730 miles away! Jon and Justin
              have direct flights to Lexington, while Charlie and Rose will meet
              at Detroit for their connecting flight in Michigan. Their travel
              costs sum up to around $2000. Emma's plane ticket alone is 45% of
              this total- pure dedication from Brother Nessie to travel to
              NatCon!
            </p>
          </div>
          <div class="img-container">
            <img src={Travel}></img>
          </div>
        </div>

        <div class="group" id="Airbnb">
          <div class="text-container">
            <h2>Housing</h2>
            <p>
              Our Brothers have worked with Eta Gamma Sisters to coordinate
              housing for NatCon. For a total of 8 people staying for 5 nights
              is around $1276 -<b>$255 each night</b>!!! Each Brother and Sister
              pitched in $169 to make up this cost.
            </p>
          </div>
          <div class="img-container">
            <img src={Airbnb}></img>
          </div>
        </div>

        <h1>Consider Supporting Our Brothers!</h1>
        <div class="group" id="Support-Brothers">
          <div class="img-container">
            <img src={DonorInfo}></img>
          </div>
          <div class="text-container">
            <h2>Where Your Donations Go</h2>
            <p>
              Any support for our Brothers on their trip to NatCon is beyond
              helpful. Your donation can range from a cup of coffee's worth to a
              night for a Brother at their Airbnb! The fact that you took the
              time and resources means the world for not only for these 5
              Brothers but also for Theta Beta. Dominador Coloyan, one of Theta
              Beta's founders, covered the cost for our Brother's registration
              fees. This is 21% of our Brother's costs to attend NatCon! Go Dom!
            </p>
          </div>
        </div>
        <div class="group" id="Venmo-Donation">
          <div class="img-container">
            <img src={Don1}></img>
          </div>
          <div class="text-container">
            <h2>Make A Quick Donation Via Venmo!</h2>
            <p>
              This the fastest way of donating as Theta Beta's Treasurer can
              disperse the amount to our Brothers in a timely manner! For
              example, if you choose to support Brothers' meals, they will be
              able to use your donation during NatCon!
            </p>
          </div>
          <a href="https://venmo.com/u/s3ren1ty" target="_blank">
            Click to Donate!
          </a>
        </div>
        <div class="group" id="Official-Donation">
          <div class="img-container">
            <img src={Don2}></img>
          </div>
          <div class="text-container">
            <h2>Donate via BU Student Activites Office!</h2>
            <p>
              Before you go to the BU Form to send a donation:<br></br>
              Donating using this method is valid, however has some nuances. Due
              to the Student Activities Office procedure, it may not be until
              the fall semester that our Treasurer can disperse your donation!
              It is still a valid option nonetheless and will be taken care of!{" "}
              <br></br>
              <br></br>
              <b>Directions:</b>
              <br></br>
              Under “Choose Your Cause,” click on the option labeled “Student
              Clubs & Organizations.” Then in the text box where it says, “If
              other specifics about your gift designation are needed, please
              note them here:” type <b>“Kappa Kappa Psi”</b> as the organization
              you would like to donate to. If you choose to donate using this
              method, email us at kkpsi@bu.edu so we can keep an eye out for it!
            </p>
          </div>
          <a
            href="https://trusted.bu.edu/s/1759/22/form.aspx?sid=1759&gid=2&pgid=412&cid=1044&appealcode=WEBAGC-CSDN"
            target="_blank"
          >
            Click to Donate!
          </a>
        </div>

        <div class="group" id="Contact-Us">
          <div class="img-container">
            <img src={Don3}></img>
          </div>
          <div class="text-container">
            <h2>Contact Us!</h2>
            <p>Our email: Kkpsi@bu.edu</p>
          </div>
        </div>
      </div>
    </body>
  );
}

export default App;
